import { Expose, Transform } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLprAxonVIFilterSuggestion extends SnModel {
  @Expose()
  public value: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
